module.exports = __webpack_public_path__ + "static/media/icon-outdoor-trash.1b59990d.svg";